// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dancer-profile-image_imageWrapper__xawXH","rejectedOverlay":"dancer-profile-image_rejectedOverlay__51568"};